export default __webpack_public_path__ + "static/media/menu.6848cee0.svg";